import parseColor from './parseColor';
export function getWixColor(_a) {
    var colors = _a.colors, reference = _a.reference, _b = _a.opacity, opacity = _b === void 0 ? 1 : _b;
    var wixColor = colors.find(function (c) { return c.reference === reference; }) || null;
    return {
        opacity: opacity,
        value: parseColor(wixColor === null || wixColor === void 0 ? void 0 : wixColor.value, opacity).rgb(),
        name: wixColor === null || wixColor === void 0 ? void 0 : wixColor.name,
    };
}
export var wixColorParam = function (name, opacity) {
    return function (_a) {
        var colors = _a.colors;
        return getWixColor({ reference: name, opacity: opacity, colors: colors });
    };
};
//# sourceMappingURL=getWixColor.js.map